module.exports = __webpack_public_path__ + "images/hoehenlinien_x4-2436f3a2a338ba64fd75a31acdd3c7ce.png";